import { ProductVariant } from 'types/Product';

const findFirstSkuByColourOption = (skus: ProductVariant[], option: string) =>
  skus.find((sku) => sku.options.colour === option);

export default findFirstSkuByColourOption;
